export enum StatusHeteroidentificacao {
  NAO_ENVIADO = 'Não enviado',
  CANDIDATO_ENVIADO = 'Candidato enviado',
  FOTO_ENVIADA = 'Foto enviada',
  INDEFINIDO = 'Indefinido',
  INCONCLUSIVO = 'Inconclusivo',
  VALIDADO = 'Validado',
  NAO_VALIDADO = 'Não validado',
  DELETADO = 'Deletado',
  AUSENTE = 'Ausente',
  VALIDADO_ANTERIORMENTE = 'Validado anteriormente'
}

export function getStatusHeteroidentificacaoDescricao(valor: number | null | undefined): string {
  if (valor == null) return 'Não informado'
  
  const detalhes: string[] = []
  
  if ((valor & 1) !== 0) detalhes.push(StatusHeteroidentificacao.CANDIDATO_ENVIADO)
  if ((valor & 2) !== 0) detalhes.push(StatusHeteroidentificacao.FOTO_ENVIADA)
  
  const statusResultado = valor & 0xF0
  const statusMap: { [key: number]: string } = {
    16: StatusHeteroidentificacao.INDEFINIDO,
    32: StatusHeteroidentificacao.INCONCLUSIVO,
    48: StatusHeteroidentificacao.VALIDADO,
    64: StatusHeteroidentificacao.NAO_VALIDADO,
    80: StatusHeteroidentificacao.DELETADO,
    96: StatusHeteroidentificacao.AUSENTE,
    112: StatusHeteroidentificacao.VALIDADO_ANTERIORMENTE
  }
  
  if (statusMap[statusResultado]) {
    detalhes.push(statusMap[statusResultado])
  }
  
  return detalhes.length > 0 ? detalhes[detalhes.length - 1] : StatusHeteroidentificacao.NAO_ENVIADO
}

export function getStatusHeteroidentificacaoDetalhado(valor: number | null | undefined): string {
  if (valor == null) return 'Não informado'
  
  const detalhes: string[] = []
  
  if ((valor & 1) !== 0) detalhes.push(StatusHeteroidentificacao.CANDIDATO_ENVIADO)
  if ((valor & 2) !== 0) detalhes.push(StatusHeteroidentificacao.FOTO_ENVIADA)
  
  const statusResultado = valor & 0xF0
  const statusMap: { [key: number]: string } = {
    16: StatusHeteroidentificacao.INDEFINIDO,
    32: StatusHeteroidentificacao.INCONCLUSIVO,
    48: StatusHeteroidentificacao.VALIDADO,
    64: StatusHeteroidentificacao.NAO_VALIDADO,
    80: StatusHeteroidentificacao.DELETADO,
    96: StatusHeteroidentificacao.AUSENTE,
    112: StatusHeteroidentificacao.VALIDADO_ANTERIORMENTE
  }
  
  if (statusMap[statusResultado]) {
    detalhes.push(statusMap[statusResultado])
  }
  
  return detalhes.length > 0 ? detalhes.join(' | ') : StatusHeteroidentificacao.NAO_ENVIADO
}
